import React, { Component } from 'react';

import * as EmailConfirmationActions from './EmailConfirmationActions';

import { Container, H1 } from 'components';

import './EmailConfirmationPage.css';

import AppStore from 'AppStore';
//import CustomButton from '../form/components/custom-button/index';
import { CustomButton } from 'modules/form';

class EmailConfirmationPage extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.state.loading = AppStore.getLoadingState();
        //this.interval = setInterval(this.checkProfile, 1000);
    }
    componentWillMount = () => {
        AppStore.on('loading_change', this.onLoadingChange);
    };

    componentWillUnmount = () => {
        AppStore.removeListener('loading_change', this.onLoadingChange);
    };

    onLoadingChange = () => {
        console.error('LOading change ' + AppStore.getLoadingState());
        this.setState({ loading: AppStore.getLoadingState() });
    };
    onSubmitHandler = () => {
        if (AppStore.getUser().status == 'active') {
            window.location.reload();
        } else {
            //resend email
            EmailConfirmationActions.resendWelcomeEmail();
        }
    };

    checkProfile = () => {
        if (AppStore.getUser().status == 'active') {
            window.location.reload();
        }
    };

    render() {
        return (
            <div className="email-confirmation-page page">
                <Container>
                    <H1>A confirmation email has been sent</H1>
                    <p>
                        Thank you for signing up. There is just one more step.
                        Please check your email; and respond. After responding,
                        you will have use of the quoting tool for 30 days.
                    </p>
                    <br />
                    <CustomButton
                        align="right"
                        type="primary-button"
                        action={this.onSubmitHandler}
                        label="Resend Email"
                        loading={this.state.loading}
                    />
                </Container>
            </div>
        );
    }
}

export default EmailConfirmationPage;



// WEBPACK FOOTER //
// ./src/modules/email-confirmation/EmailConfirmationPage.jsx